<template>
    <div id="loan-detail">
        <vx-card>
            <h6 class="success bold">Crédito</h6>
        </vx-card>
    </div>
</template>

<script>
export default {
    data: () => ({

    }),
    props: {
        source: String
    }
}
</script>